<script setup lang="ts">
  import LoadingSpinner from '../LoadingSpinner.vue';
</script>

<template>
  <div
    class="absolute flex flex-col justify-center w-full top-[48px]"
    style="height: calc(100% - 48px)"
  >
    <div class="flex flex-col items-center w-full text-center gap-y-1">
      <LoadingSpinner class="text-xl" />
      <p class="w-fit mx-auto">Loading...</p>
    </div>
  </div>
</template>

<style scoped></style>
